import tabAreaActive from './tab_area-active.webp';
import tabAreaInactive from './tab_area-inactive.webp';
import tabMissionActive from './tab_mission-active.webp';
import tabMissionInactive from './tab_mission-inactive.webp';
import cardUnlock from './card-unlock.webp';
import cardUnlockAlt from './card-unlock-alt.webp';

export const cardPageImages = {
  tabAreaActive,
  tabAreaInactive,
  tabMissionActive,
  tabMissionInactive,
  cardUnlock,
  cardUnlockAlt,
};
